<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == 'agro-fasecultivo') {
            next({ name: 'agro-fasecultivo-list' });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == 'agro-fasecultivo') {
            this.$router.push({ name: 'agro-fasecultivo-list' });
        }
    },
};
</script>
